import type { CryptoAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";



const CAPITAL_TAX_RATE = 0.25
const YESEF_TAX_RATE = 0.03
const EXTRA_YESEF_FOR_CAPITAL_GAINS_2025 = 0.02

export const calculateCryptoBalance = (
  userProduct: CryptoAsset,
  withCash: boolean,
  cashCurrency: Fiat,
  cryptoCurrency: Fiat
) => {
  const cash = withCash
    ? convertCurrency(
        Number(userProduct?.cash) || 0,
        cryptoCurrency,
        cashCurrency
      )
    : 0;
    const coins = userProduct?.cryptoData || [];

    const finalTaxRate = getCryptoTaxRate(userProduct);  
    
  return coins.reduce((sum, current) => {
      const amount = current?.amount || 0;
      const price = current?.coinRate || 0;
      const taxablePrice = Math.max(price - (current?.purchasePrice || 0), 0);
      return sum + amount * price - (amount * taxablePrice * finalTaxRate);
  }, cash);
};

export const convertCryptoBalance = (
  userProduct: CryptoAsset,
  currencies: {
    baseCurrency: Fiat;
    cashCurrency: Fiat;
    cryptoCurrency: Fiat;
  }
) => {
  const { baseCurrency, cashCurrency, cryptoCurrency } = currencies;
  const balance = calculateCryptoBalance(
    userProduct,
    true,
    cashCurrency,
    cryptoCurrency
  );

  return convertCurrency(balance, baseCurrency, cryptoCurrency);
};



export function getCryptoTaxRate(userProduct: CryptoAsset) {
  const coins = userProduct?.cryptoData || [];
  const totalCapitalLosses = (userProduct?.offsetLosses ? coins.reduce((sum, coin) => {
    const coinPrice = coin?.coinRate || 0;
    const purchasePrice = coin?.purchasePrice || 0;
    return sum + Math.min(coinPrice - purchasePrice, 0);
  }, 0
  ) : 0);
  const totalCapitalGains = (userProduct?.offsetLosses ? coins.reduce((sum, coin) => {
    const coinPrice = coin?.coinRate || 0;
    const purchasePrice = coin?.purchasePrice || 0;
    return sum + Math.max(coinPrice - purchasePrice, 0);
  }, 0
  ) : 0);
  const taxRate = userProduct?.showAfterTax ? (CAPITAL_TAX_RATE + (userProduct?.yesefTax ? YESEF_TAX_RATE + EXTRA_YESEF_FOR_CAPITAL_GAINS_2025 : 0)) : 0;
  //now we want to reduce the tax Rate by the proportion of capital losses from capital gains if losses > gains tax rate should be zero
  //else tax rate should be reduced according to the percantage tax losses arefrom tax gains
  let taxRateAfterLosses = Math.max((taxRate - (Math.abs(totalCapitalLosses) / totalCapitalGains) * taxRate), 0);
  const finalTaxRate = userProduct?.offsetLosses ? taxRateAfterLosses : taxRate;
  return finalTaxRate;
}